var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "call-to-book" }, [
    _c(
      "div",
      { ref: "header", staticClass: "call-to-book-header" },
      [
        _c("header-close", { attrs: { back: _vm.getBack } }),
        _vm._v(" "),
        _c("h6", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.tc("booking.callToBook"))),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "call-to-book-body",
        style: [{ height: _vm.scrollHeight + "px" }],
      },
      [
        _c(
          "picture",
          {
            directives: [
              {
                name: "lazyload",
                rawName: "v-lazyload",
                value: {
                  src: _vm.tc("booking.callToBookImage"),
                  variant: "call-to-book",
                },
                expression:
                  "{\n        src: tc('booking.callToBookImage'),\n        variant: 'call-to-book'\n      }",
              },
            ],
            staticClass: "image-wrapper",
          },
          [
            _c("img", {
              staticClass: "image",
              attrs: {
                src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                alt: _vm.tc("booking.callToBookImageAlt"),
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _vm._v(_vm._s(_vm.tc("booking.callToBookText"))),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "hotel-info" }, [
          _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.hotelName))]),
          _vm._v(" "),
          _c("div", {
            staticClass: "address",
            domProps: { innerHTML: _vm._s(_vm.hotelAddress) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "phone" }, [
            _c("a", { attrs: { href: "tel:" + _vm.hotelPhone } }, [
              _vm._v(_vm._s(_vm.hotelPhone)),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { ref: "footer", staticClass: "call-to-book-footer" }, [
      _c("div", { staticClass: "confirmation-cta" }, [
        _c(
          "a",
          { staticClass: "phone", attrs: { href: "tel:" + _vm.hotelPhone } },
          [_vm._v("\n        " + _vm._s(_vm.tc("booking.callUs")) + "\n      ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "email", attrs: { href: "mailto:" + _vm.hotelEmail } },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.tc("formFields.email")) + "\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }